(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["anzee-anzu-chat"] && !Shopify.designMode) return;
  try {
    (() => {
    // 全角の句読点や括弧はパスの一部ではないので、リンクの末尾から外す。
    const PRODUCT_PATH = /\/products\/[^\s、。）)」]+/g;
    /** 直近8往復まで送る。それ以前はサーバー側でも落とされる。 */
    const HISTORY_LIMIT = 16;

    /** 物理キーボードのある環境か。Enter送信と、開いた直後のフォーカスに使う。 */
    function onDesktop() {
      return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    }

    document.querySelectorAll('[data-anzu-chat]').forEach(setUp);

    function setUp(root) {
      const endpoint = root.dataset.endpoint;
      const body = root.querySelector('[data-anzu-body]');
      const opener = root.querySelector('[data-anzu-open]');
      const log = root.querySelector('[data-anzu-log]');
      const form = root.querySelector('[data-anzu-form]');
      const input = root.querySelector('[data-anzu-input]');
      const send = root.querySelector('[data-anzu-send]');
      if (!endpoint || !body || !log || !form || !input || !send) return;

      // ロケール接頭辞（/en/ 等）を前置する。在庫リストのURLは相対パスで届く。
      const rootUrl = (root.dataset.root || '/').replace(/\/$/, '');
      // 商品ページからは data 属性で、/pages/anzu?product=handle からはクエリで届く。
      const product =
        root.dataset.product || new URLSearchParams(location.search).get('product') || '';

      const history = [];
      let busy = false;

      function productLink(path, label) {
        const a = document.createElement('a');
        a.className = 'anzu-chat__link';
        a.href = rootUrl + path;
        a.textContent = label;
        return a;
      }

      function turn(modifier) {
        const el = document.createElement('div');
        el.className = 'anzu-chat__turn' + (modifier ? ' anzu-chat__turn--' + modifier : '');
        return el;
      }

      function paragraph(text, modifier) {
        const p = document.createElement('p');
        p.className = 'anzu-chat__line' + (modifier ? ' anzu-chat__line--' + modifier : '');
        p.textContent = text;
        return p;
      }

      /**
       * 杏の返事を組み立てる。
       *
       * モデルの出力なので innerHTML は使わない。商品説明にHTMLらしき文字列が
       * 混じっていても、テキストとして表示されるようにテキストノードで組む。
       */
      function anzuTurn(text) {
        const el = turn();

        text.split('\n').forEach((line) => {
          const trimmed = line.trim();
          if (!trimmed) return;

          // URLだけの行は、パスを見せずにリンクとして置く。
          if (/^\/products\/\S+$/.test(trimmed)) {
            el.appendChild(productLink(trimmed, root.dataset.linkLabel));
            return;
          }

          const p = paragraph('');
          let cursor = 0;
          trimmed.replace(PRODUCT_PATH, (match, index) => {
            p.appendChild(document.createTextNode(trimmed.slice(cursor, index)));
            p.appendChild(productLink(match, match));
            cursor = index + match.length;
            return match;
          });
          p.appendChild(document.createTextNode(trimmed.slice(cursor)));
          el.appendChild(p);
        });

        return el;
      }

      function append(node) {
        log.appendChild(node);
        node.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        return node;
      }

      function thinking() {
        const waiting = append(paragraph(root.dataset.thinking, 'thinking'));
        waiting.classList.add('anzu-chat__thinking');
        return waiting;
      }

      function messageFor(response, payload) {
        if (response.status === 429) return root.dataset.errorBusy;
        if (payload && payload.error === 'rate_limited') return root.dataset.errorBusy;
        return root.dataset.errorGeneric;
      }

      function setBusy(state) {
        busy = state;
        send.disabled = state || input.value.trim() === '';
        input.disabled = state;
      }

      function grow() {
        input.style.height = 'auto';
        input.style.height = input.scrollHeight + 'px';
      }

      async function post(payload) {
        try {
          const response = await fetch(endpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
          });
          return { response, payload: await response.json().catch(() => null) };
        } catch {
          return { response: null, payload: null };
        }
      }

      async function ask(text) {
        history.push({ role: 'user', content: text });
        const asked = turn('you');
        asked.appendChild(paragraph(text));
        append(asked);

        input.value = '';
        grow();
        setBusy(true);
        const waiting = thinking();

        const answer = await post({
          messages: history.slice(-HISTORY_LIMIT),
          product: product || undefined,
        });
        waiting.remove();

        if (!answer.response || !answer.response.ok || !answer.payload || !answer.payload.reply) {
          const failed = turn();
          failed.appendChild(paragraph(
            answer.response
              ? messageFor(answer.response, answer.payload)
              : root.dataset.errorGeneric,
            'error',
          ));
          append(failed);
        } else {
          history.push({ role: 'assistant', content: answer.payload.reply });
          append(anzuTurn(answer.payload.reply));
        }

        setBusy(false);
        input.focus();
      }

      /**
       * 開いた瞬間の一言。杏の方から先に口を開く。
       *
       * 商品名はサーバーが在庫から引くので、こちらからは handle しか渡さない。
       * 失敗したときは、最初に見えるものがエラー文にならないよう導入文に戻す。
       */
      async function greet() {
        setBusy(true);
        const waiting = thinking();

        const answer = await post({ messages: [], product: product, opening: true });
        waiting.remove();

        if (answer.response && answer.response.ok && answer.payload && answer.payload.reply) {
          history.push({ role: 'assistant', content: answer.payload.reply });
          append(anzuTurn(answer.payload.reply));
        } else {
          const resting = turn();
          resting.appendChild(paragraph(root.dataset.openingFallback));
          append(resting);
        }

        setBusy(false);
      }

      if (opener) {
        opener.addEventListener('click', () => {
          opener.hidden = true;
          body.hidden = false;
          // スマホでここにフォーカスすると、杏が話し出す前にキーボードが服の
          // 写真を覆ってしまう。物理キーボードのある環境だけ先に当てる。
          if (onDesktop()) input.focus({ preventScroll: true });
          if (product) greet();
        }, { once: true });
      }

      form.addEventListener('submit', (event) => {
        event.preventDefault();
        const text = input.value.trim();
        if (!text || busy) return;
        ask(text);
      });

      input.addEventListener('input', () => {
        grow();
        send.disabled = busy || input.value.trim() === '';
      });

      // 物理キーボードのある環境だけ Enter で送る。スマホでは改行のままにする。
      input.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' || event.shiftKey || event.isComposing) return;
        if (!onDesktop()) return;
        event.preventDefault();
        form.requestSubmit();
      });

      setBusy(false);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
